module.exports = __webpack_public_path__ + "static/media/bicam_logo.407cb6f8.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/bicam_logo.svg
// module id = 340
// module chunks = 0